import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom"; // Fixed: removed duplicate import
import { Baseurl } from "../baseurl";
import axios from "axios";
import {
  FaPrint,
  FaDownload,
  FaCheckCircle,
  FaTimesCircle,
  FaBatteryFull,
  FaBolt,
  FaCar,
  FaTruck,
  FaBus,
  FaMotorcycle,
  FaUser,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaFileInvoiceDollar,
  FaClipboardCheck,
  FaSignature,
  FaStamp,
  FaShieldAlt,
  FaExclamationTriangle,
  FaCogs,
  FaWrench,
  FaIndustry,
  FaTachometerAlt,
  FaPalette,
  FaGasPump,
  FaIdCard,
  FaCertificate,
  FaImages,
  FaVideo,
  FaExternalLinkAlt,
  FaPlayCircle,
  FaFileAlt,
  FaBuilding,
  FaMobileAlt,
  FaGlobe,
} from "react-icons/fa";
import { IoIosDocument } from "react-icons/io";
import { MdDangerous } from "react-icons/md";
import { GiBouncingSpring } from "react-icons/gi";
export const ValuationReport = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [data, setData] = useState(null);
  const [organisationData, setorganisationData] = useState("");
  // Vehicle type specific images
  const vehicleImages = {
    evTwoWheeler:
      "https://imageapi.mcollect.co.in/auctionVehicleuploads/files-1769751201184.png",
    evThreeWheeler:
      "https://imageapi.mcollect.co.in/auctionVehicleuploads/files-1769751240139.jpg",
    evFourWheeler:
      "https://imageapi.mcollect.co.in/auctionVehicleuploads/files-1769751391892.jpg",
    evCommercial:
      "https://imageapi.mcollect.co.in/auctionVehicleuploads/files-1769751391892.jpg",
    evBus:
      "https://imageapi.mcollect.co.in/auctionVehicleuploads/files-1769751201183.jpg",
  };
  // Vehicle type icons
  const vehicleIcons = {
    evTwoWheeler: <FaMotorcycle className="icon" />,
    evThreeWheeler: (
      <FaCar className="icon" style={{ transform: "scaleX(-1)" }} />
    ),
    evFourWheeler: <FaCar className="icon" />,
    evCommercial: <FaTruck className="icon" />,
    evBus: <FaBus className="icon" />,
  };

  // Vehicle type colors
  const vehicleColors = {
    evTwoWheeler: "#1a1f3d",
    evThreeWheeler: "#1a1f3d",
    evFourWheeler: "#1a1f3d",
    evCommercial: "#1a1f3d",
    evBus: "#1a1f3d",
  };

  useEffect(() => {
    fetchCaseDetails();
  }, [id]);

  const fetchCaseDetails = async () => {
    setLoading(true);
    setError("");
    try {
      const url = `${Baseurl}/api/cases/individualCaseDetails/${id}`;
      const response = await axios.get(url);

      if (response.data.success) {
        const caseData = response.data.caseDetails;
        console.log(caseData, "caseData");
        setData(caseData);
        if (caseData?.caseByAgency && caseData?.organisation?.id) {
          getAgencyData(caseData);
        } else {
          getOrgData(caseData);
        }
      } else {
        setError(response.data.message || "Failed to fetch case details");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Failed to fetch case details");
      console.error("Error fetching case details:", err);
    } finally {
      setLoading(false);
    }
  };

  const getAgencyData = async (caseData) => {
    const url = `${Baseurl}/api/agency/details/${caseData?.organisation?.id}`;
    const resp = await axios.get(url);
    if (resp.data.success) {
      setorganisationData(resp.data.data);
    }
  };
  const getOrgData = async (caseData) => {
    const url = `${Baseurl}/api/admin/details/${caseData?.organisation?.id}`;
    const resp = await axios.get(url);
    if (resp.data.success) {
      setorganisationData(resp.data.admin);
    }
  };
  console.log(organisationData, "organisationData");
  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading valuation report...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <FaTimesCircle className="error-icon" />
        <h3>Error Loading Report</h3>
        <p>{error}</p>
        <button onClick={fetchCaseDetails} className="retry-btn">
          Retry
        </button>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="no-data">
        <FaExclamationTriangle className="warning-icon" />
        <p>No data available for this valuation report</p>
      </div>
    );
  }

  // Helper function to extract value from form field objects
  const extractFormFieldValue = (field) => {
    if (!field) return "N/A";

    if (typeof field === "object" && field !== null) {
      if ("value" in field) {
        return field.value || "N/A";
      }
      if (Array.isArray(field)) {
        return field.join(", ") || "N/A";
      }
      const firstValue = Object.values(field)[0];
      return firstValue || "N/A";
    }

    return field.toString() || "N/A";
  };

  // Helper function to get vehicle-specific data
  const getVehicleSpecificData = () => {
    const conditionData = data.condition || {};

    if (Object.keys(conditionData).length === 0 && data.vehicleType) {
      const vehicleTypeMap = {
        evTwoWheeler: "evTwoWheeler",
        evThreeWheeler: "evThreeWheeler",
        evFourWheeler: "evFourWheeler",
        evCommercial: "evCommercial",
        evBus: "evBus",
      };

      const vehicleTypeKey = vehicleTypeMap[data.vehicleType];
      if (vehicleTypeKey && data[vehicleTypeKey]) {
        return data[vehicleTypeKey];
      }
    }

    return conditionData;
  };

  // Get all images from data
  const getAllImages = () => {
    const images = [];

    // Get vehicle images
    if (data.images) {
      Object.entries(data.images).forEach(([key, value]) => {
        if (value && typeof value === "string" && value.trim() !== "") {
          images.push({
            url: value,
            title: key
              .replace(/([A-Z])/g, " $1")
              .replace(/^./, (str) => str.toUpperCase()),
            type: "image",
          });
        } else if (value && typeof value === "object" && value.url) {
          images.push({
            url: value.url,
            title: key
              .replace(/([A-Z])/g, " $1")
              .replace(/^./, (str) => str.toUpperCase()),
            type: "image",
            ...value,
          });
        }
      });
    }

    // Get any additional image URLs from other fields
    if (data.vehicleImage) {
      images.push({
        url: data.vehicleImage,
        title: "Vehicle Image",
        type: "image",
      });
    }

    return images;
  };

  const getVehicleAccessories = () => {
    return data.accessories || {};
  };

  const formatDate = (date) => {
    if (!date) return "N/A";
    return new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return "N/A";
    return `₹${parseInt(amount).toLocaleString("en-IN")}`;
  };

  const getValuationSummary = () => {
    console.log(data.priceTag, "data.priceTag");
    return {
      purchasePrice: data.priceTag?.purchasePrice || "N/A",
      sellPrice: data.priceTag?.sellPrice || "To be assessed",
      totalCostToRepair:
        data?.priceTag?.marketPrice -
        data?.priceTag?.profitAfterRepair -
        data?.priceTag?.sellPrice -
        data?.priceTag?.labourCost -
        data?.priceTag?.additionalCost,
      afterRepairValue: data.priceTag?.afterRepairValue || "N/A",
      profitAfterRepair: data?.priceTag?.profitAfterRepair,
      recommendedAction:
        data.recommendationByInspector?.recommendation.toUpperCase() ||
        data.inspections?.[0]?.inspectionObservation.toUpperCase() ||
        "Further inspection required",
    };
  };

  const formatVehicleType = (type) => {
    if (!type) return "EV Four Wheeler";
    return type
      .replace("ev", "EV ")
      .replace(/([A-Z])/g, " $1")
      .trim();
  };

  const getVehicleImage = () => {
    const type = data.vehicleType || "evFourWheeler";
    if (data.images?.selfieWithVehicle) {
      return data.images.selfieWithVehicle;
    } else {
      return vehicleImages[type] || vehicleImages.evFourWheeler;
    }
  };

  const getVehicleColor = () => {
    const type = data.vehicleType || "evFourWheeler";
    return vehicleColors[type] || vehicleColors.evFourWheeler;
  };

  const getVehicleIcon = () => {
    const type = data.vehicleType || "evFourWheeler";
    return vehicleIcons[type] || vehicleIcons.evFourWheeler;
  };

  // Helper function to flatten and filter form data
  const getFilteredFormData = (vehicleData) => {
    if (!vehicleData || typeof vehicleData !== "object") {
      return {};
    }

    const result = {};

    const processCategory = (categoryName, categoryData) => {
      if (!categoryData || typeof categoryData !== "object") {
        return null;
      }

      const categoryItems = {};
      let hasData = false;

      // Process each field in the category
      Object.entries(categoryData).forEach(([fieldKey, fieldValue]) => {
        if (fieldKey === "formType" || fieldKey === "options") {
          return;
        }

        // If field is a direct value object (like motorCondition: {value: "Good", formType: "dropdown"})
        if (
          typeof fieldValue === "object" &&
          fieldValue !== null &&
          "value" in fieldValue
        ) {
          const extractedValue = extractFormFieldValue(fieldValue.value);
          if (extractedValue !== "N/A") {
            categoryItems[fieldKey] = extractedValue;
            hasData = true;
          }
        }
        // If field is a nested object (like batterySystem: {batteryType: "", batteryCapacity: ""})
        else if (typeof fieldValue === "object" && fieldValue !== null) {
          // Check if it's a nested structure with simple key-value pairs
          let hasNestedData = false;
          Object.entries(fieldValue).forEach(([nestedKey, nestedValue]) => {
            if (nestedKey === "formType" || nestedKey === "options") {
              return;
            }

            // Handle nested value objects (like front: {value: "Good", formType: "dropdown"})
            if (
              typeof nestedValue === "object" &&
              nestedValue !== null &&
              "value" in nestedValue
            ) {
              const nestedExtractedValue = extractFormFieldValue(
                nestedValue.value,
              );
              if (nestedExtractedValue !== "N/A") {
                categoryItems[`${fieldKey}_${nestedKey}`] =
                  nestedExtractedValue;
                hasNestedData = true;
              }
            }
            // Handle direct string/number values in nested objects
            else if (
              typeof nestedValue !== "object" &&
              nestedValue !== null &&
              nestedValue !== ""
            ) {
              categoryItems[`${fieldKey}_${nestedKey}`] =
                extractFormFieldValue(nestedValue);
              hasNestedData = true;
            }
          });

          if (hasNestedData) {
            hasData = true;
          }
        }
        // Handle direct string/number values
        else if (fieldValue !== null && fieldValue !== "") {
          categoryItems[fieldKey] = extractFormFieldValue(fieldValue);
          hasData = true;
        }
      });

      if (hasData) {
        result[categoryName] = categoryItems;
      }

      return hasData ? categoryName : null;
    };

    // Define the main categories to look for based on your schema
    const mainCategories = [
      "batterySystem",
      "motorCondition",
      "transmissionType",
      "suspensionCondition",
      "brakesCondition",
      "tyres",
      "cabin",
      "body",
      "electricals",
      "accessories",
      "accidentalStatus",
      "maintenanceLevel",
      "motor", // For evTwoWheeler, evFourWheeler, etc.
      "controller", // For evTwoWheeler
      "transmission", // For other vehicle types
      "tyresNConditions", // For evTwoWheeler, evFourWheeler, etc.
      "vehicleExterior", // For evTwoWheeler, evFourWheeler
      "vehicleInterior", // For evFourWheeler
      "cabinInterior", // For evCommercial
      "drivetrain", // For evBus
    ];

    // Process each category
    const validCategories = [];
    mainCategories.forEach((category) => {
      if (vehicleData[category]) {
        const processedCategory = processCategory(
          category,
          vehicleData[category],
        );
        if (processedCategory) {
          validCategories.push(processedCategory);
        }
      }
    });

    return result;
  };
  const formatCategoryName = (categoryKey) => {
    const categoryNames = {
      batterySystem: "Battery System",
      motorCondition: "Motor Condition",
      transmissionType: "Transmission Type",
      suspensionCondition: "Suspension Condition",
      brakesCondition: "Brakes Condition",
      tyres: "Tyres",
      cabin: "Cabin",
      body: "Body",
      electricals: "Electricals",
      accessories: "Accessories",
      accidentalStatus: "Accidental Status",
      maintenanceLevel: "Maintenance Level",
      motor: "Motor",
      controller: "Controller",
      transmission: "Transmission",
      tyresNConditions: "Tyres & Conditions",
      vehicleExterior: "Vehicle Exterior",
      vehicleInterior: "Vehicle Interior",
      cabinInterior: "Cabin Interior",
      drivetrain: "Drivetrain",
    };

    return (
      categoryNames[categoryKey] ||
      categoryKey
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, (str) => str.toUpperCase())
    );
  };
  const formatFieldName = (fieldKey) => {
    // Replace underscores with spaces
    let formatted = fieldKey.replace(/_/g, " ");

    // Add spaces before capital letters
    formatted = formatted.replace(/([A-Z])/g, " $1");

    // Capitalize first letter of each word
    formatted = formatted
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());

    // Handle specific cases
    formatted = formatted.replace(/Lh\b/g, "Left");
    formatted = formatted.replace(/Rh\b/g, "Right");
    formatted = formatted.replace(/Soc\b/g, "SOC");
    formatted = formatted.replace(/Adas\b/g, "ADAS");
    formatted = formatted.replace(/Gps\b/g, "GPS");
    formatted = formatted.replace(/Usb\b/g, "USB");
    formatted = formatted.replace(/Rpm\b/g, "RPM");
    formatted = formatted.replace(/Kw\b/g, "kW");

    return formatted.trim();
  };
  // Handle opening media in new tab
  const openMediaInNewTab = (url) => {
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  // Print functionality
  const handlePrint = () => {
    window.print();
  };

  const handleDownloadPDF = () => {
    alert("PDF download functionality would be implemented here");
  };

  return (
    <div className="valuation-report-container">
      {/* Main Report */}
      <div className="valuation-report">
        {/* Page 1: Header and Basic Info */}
        <div className="page page-1">
          {/* Header */}
          <div className="report-header">
            <div className="company-header">
              {data?.caseByAgency ? (
                <div className="company-name">
                  <img
                    src={data?.organisation?.logo}
                    className="company-logo"
                    style={{ width: "300px" }}
                  />
                  <h1>{data?.organisation?.name}</h1>
                  <p className="company-tagline">
                    Certified Vehicle Valuation Experts
                  </p>
                </div>
              ) : (
                <div className="company-name">
                  <img
                    src="https://imageapi.mcollect.co.in/auctionVehicleuploads/files-1769758233499.jpg"
                    className="company-logo"
                    style={{ width: "300px" }}
                  />
                  <h1> mCollect</h1>
                  <p className="company-tagline">
                    Certified Vehicle Valuation Experts
                  </p>
                </div>
              )}
              {organisationData && data?.caseByAgency ? (
                <div className="company-contact">
                  <p>
                    <FaMapMarkerAlt />{" "}
                    {organisationData?.companyDetails?.registeredAddress}
                  </p>
                  <p>
                    <FaPhone />{" "}
                    {organisationData?.companyDetails?.contactNumber}
                  </p>
                  <p>
                    <FaEnvelope /> {organisationData?.companyDetails?.email}
                  </p>
                  <p>
                    <FaGlobe /> {organisationData?.companyDetails?.gst}
                  </p>
                </div>
              ) : (
                <div className="company-contact">
                  <p>
                    <FaMapMarkerAlt /> mCollect 1-8-343, 1st Floor, MNJ Palace,
                    IAL Colony, Begumpet, Hyderabad-16
                  </p>
                  <p>
                    <FaPhone /> +91-9217807533
                  </p>
                  <p>
                    <FaEnvelope /> info@mcollect.co.in
                  </p>
                  <p>
                    <FaGlobe /> https://mcollect.co.in
                  </p>
                </div>
              )}
            </div>
            <div className="report-title-section">
              <FaCertificate className="title-icon" />
              <div>
                <h2>VEHICLE VALUATION REPORT</h2>
                <p className="report-subtitle">
                  Comprehensive Assessment & Market Valuation
                </p>
              </div>
              <div className="report-badge">
                <span>CONFIDENTIAL</span>
              </div>
            </div>
          </div>

          {/* Report Summary Section */}
          <div className="report-summary-section">
            <div className="summary-card-main">
              <h3>
                <FaFileAlt /> Report Summary
              </h3>
              <div className="summary-details">
                <div className="summary-item">
                  <span className="summary-label">Report No:</span>
                  <span className="summary-value">
                    {data.caseID || "ASSET-000001"}
                  </span>
                </div>
                <div className="summary-item">
                  <span className="summary-label">Date:</span>
                  <span className="summary-value">
                    {formatDate(new Date())}
                  </span>
                </div>
                <div className="summary-item">
                  <span className="summary-label">Purpose:</span>
                  <span className="summary-value">
                    {data.valuationPurpose || "Loan Assessment"}
                  </span>
                </div>
                <div className="summary-item">
                  <span className="summary-label">Case Type:</span>
                  <span className="summary-value">
                    {data.caseType || "Insurance"}
                  </span>
                </div>
              </div>
            </div>

            <div className="status-section">
              <div className="status-badge-main">
                <span
                  className={`status-indicator ${data.statusText?.toLowerCase()}`}
                ></span>
                <span className="status-text">
                  {data.statusText || "Case Id Created"}
                </span>
              </div>
              <div className="vehicle-type-display">
                {getVehicleIcon()}
                <span>{formatVehicleType(data.vehicleType)}</span>
              </div>
            </div>
          </div>

          {/* Client & Vehicle Info */}
          <div className="client-vehicle-info">
            <div className="client-info">
              <h3>
                <FaUser /> Client Information
              </h3>
              <div className="client-details-grid">
                <div className="client-detail">
                  <span className="detail-label">Name:</span>
                  <span className="detail-value">
                    {data?.requesterName || "Uneesh Patel"}
                  </span>
                </div>
                <div className="client-detail">
                  <span className="detail-label">Phone:</span>
                  <span className="detail-value">
                    {data?.requesterPhone || "+91-XXXXXXXXXX"}
                  </span>
                </div>
                <div className="client-detail">
                  <span className="detail-label">Organisation:</span>
                  <span className="detail-value">
                    {data.requesterBranch || "owner@example.com"}
                  </span>
                </div>
              </div>
            </div>

            <div className="vehicle-main-image">
              <div className="image-frame">
                <img
                  src={getVehicleImage()}
                  alt="Vehicle"
                  className="vehicle-main-img"
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.parentElement.innerHTML = `
                      <div class="vehicle-image-placeholder" style="background: ${getVehicleColor()}20">
                        ${getVehicleIcon()}
                        <span>${formatVehicleType(data.vehicleType)}</span>
                      </div>
                    `;
                  }}
                />
                <div className="image-caption">Vehicle Photograph</div>
              </div>
            </div>
          </div>

          {/* Vehicle Specifications */}
          <div className="vehicle-specifications">
            <h3>
              <IoIosDocument /> Vehicle Specifications
            </h3>
            <div className="specs-grid">
              <div className="spec-item">
                <span className="spec-label">
                  <FaIdCard /> Registration No:
                </span>
                <span className="spec-value">
                  {data.regdNo || data.vehicleEdetails?.regNo || "GJ06RC2604"}
                </span>
              </div>
              <div className="spec-item">
                <span className="spec-label">
                  <FaIndustry /> Make:
                </span>
                <span className="spec-value">
                  {data.brand ||
                    data.vehicleEdetails?.vehicleManufacturerName ||
                    "BMW"}
                </span>
              </div>
              <div className="spec-item">
                <span className="spec-label">
                  <FaCogs /> Model:
                </span>
                <span className="spec-value">
                  {data.model ||
                    data.vehicleEdetails?.model ||
                    "IX XDRIVE50 SPORT"}
                </span>
              </div>
              <div className="spec-item">
                <span className="spec-label">
                  <FaWrench /> Variant:
                </span>
                <span className="spec-value">{data.variant || "Sport"}</span>
              </div>
              <div className="spec-item">
                <span className="spec-label">
                  <FaCalendarAlt /> Year:
                </span>
                <span className="spec-value">
                  {data.manufacturingDate ||
                    data.vehicleEdetails?.vehicleManufacturingMonthYear ||
                    "2024"}
                </span>
              </div>
              <div className="spec-item">
                <span className="spec-label">
                  <FaGasPump /> Fuel Type:
                </span>
                <span className="spec-value">
                  {data.fueltype || data.vehicleEdetails?.type || "Electric"}
                </span>
              </div>
              <div className="spec-item">
                <span className="spec-label">Chassis No:</span>
                <span className="spec-value">
                  {data.chasisNo ||
                    data.vehicleEdetails?.chassis ||
                    "WBY22CFG3RCT40729"}
                </span>
              </div>
              <div className="spec-item">
                <span className="spec-label">Engine No:</span>
                <span className="spec-value">
                  {data.engNo || data.vehicleEdetails?.engine || "R854B650"}
                </span>
              </div>
              <div className="spec-item">
                <span className="spec-label">
                  <FaPalette /> Color:
                </span>
                <span className="spec-value">
                  {data.vehicleColor ||
                    data.vehicleEdetails?.vehicleColour ||
                    "Phytonic Blue"}
                </span>
              </div>
              <div className="spec-item">
                <span className="spec-label">
                  <FaTachometerAlt /> Odometer:
                </span>
                <span className="spec-value">
                  {data.meterReading || "13,254 km"}
                </span>
              </div>
            </div>
          </div>
          <div className="vehicle-specifications">
            <h3>
              <GiBouncingSpring /> Vehicle Accessories
            </h3>
            <div className="specs-grid">
              {Object.entries(data?.accessories).map(([key, value]) => (
                <div className="spec-item">
                  <span className="spec-label">
                    <FaIdCard /> {key.toUpperCase()}:
                  </span>
                  <span className="spec-value">
                    {value ? <FaCheckCircle /> : <MdDangerous />}
                  </span>
                </div>
              ))}
            </div>
          </div>
          <div className="vehicle-specifications">
            <h3>
              <FaCar /> Vehicle Vahan Details
            </h3>
            <div className="specs-grid">
              {Object.entries(data?.vehicleEdetails || {}).map(
                ([key, value]) => (
                  <div className="spec-item" key={key}>
                    <span className="spec-label">
                      <FaIdCard /> {key.toUpperCase()}
                    </span>

                    <span className="spec-value">{value || "-"}</span>
                  </div>
                ),
              )}
            </div>
          </div>
        </div>

        {/* Page 2: Media Gallery */}
        <div className="">
          {/* <div className="page-header">
            <h3>
              <FaImages /> Media Documentation
            </h3>
          </div> */}

          {/* Images Section */}
          {(() => {
            return (
              <div className="media-section">
                <h4 className="media-section-title">
                  <FaImages /> Document Images
                </h4>
                <div className="images-grid">
                  {Object.entries(data?.signNdoc).map(([key, value], index) => {
                    if (!value) {
                      return null;
                    }
                    return (
                      <div key={index} className="media-item">
                        <a
                          className="media-thumbnail-container"
                          href={value}
                          target="_blank"
                        >
                          <img
                            src={value}
                            alt={key}
                            className="media-thumbnail"
                            onError={(e) => {
                              e.target.style.display = "none";
                              e.target.parentElement.innerHTML = `
                                <div class="media-placeholder">
                                  <FaImages />
                                  <span>Image Not Available</span>
                                </div>
                              `;
                            }}
                          />
                          <div className="media-overlay">
                            <FaExternalLinkAlt />
                          </div>
                        </a>
                        <div className="media-info">
                          {/* <div className="media-index">#{index + 1}</div> */}
                          <div className="media-title">{key.toUpperCase()}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );

            return null;
          })()}
          {(() => {
            const images = getAllImages();
            if (images.length > 0) {
              return (
                <div className="media-section">
                  <h4 className="media-section-title">
                    <FaImages /> Inspection Images ({images.length})
                  </h4>
                  <div className="images-grid">
                    {images.map((image, index) => (
                      <div key={index} className="media-item">
                        <a
                          className="media-thumbnail-container"
                          href={image.url}
                          target="_blank"
                        >
                          <img
                            src={image.url}
                            alt={image.title}
                            className="media-thumbnail"
                            onError={(e) => {
                              e.target.style.display = "none";
                              e.target.parentElement.innerHTML = `
                                <div class="media-placeholder">
                                  <FaImages />
                                  <span>Image Not Available</span>
                                </div>
                              `;
                            }}
                          />
                          <div className="media-overlay">
                            <FaExternalLinkAlt />
                          </div>
                        </a>
                        <div className="media-info">
                          {/* <div className="media-index">#{index + 1}</div> */}
                          <div className="media-title">{image.title}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            }
            return null;
          })()}

          {/* Videos Section */}
          {(() => {
            const videos = data?.videos;
            if (videos) {
              return (
                <div className="video-section">
                  <h4 className="media-section-title">
                    <FaVideo /> Inspection Video
                  </h4>
                  <div className="video-container">
                    <a
                      className="video-thumbnail"
                      target="_blank"
                      href={videos}
                    >
                      <div className="video-icon">
                        <FaPlayCircle />
                      </div>
                      <div className="video-label">
                        Click to View Inspection Video
                      </div>
                    </a>
                  </div>
                </div>
              );
            }
            return null;
          })()}
        </div>

        {/* Page 3: Technical Assessment */}
        <div className="">
          <div className="page-header">
            <h3>
              <FaClipboardCheck /> Technical Assessment
            </h3>
            {/* <div className="page-number">Page 3</div> */}
          </div>

          {(() => {
            const vehicleData = getVehicleSpecificData();
            if (!vehicleData || Object.keys(vehicleData).length === 0) {
              return (
                <div className="no-assessment-data">
                  <FaExclamationTriangle />
                  <p>No technical assessment data available</p>
                </div>
              );
            }

            const filteredData = getFilteredFormData(vehicleData);

            // Check if we have any categorized data
            const hasCategories = Object.keys(filteredData).some(
              (key) => typeof filteredData[key] === "object",
            );

            if (!hasCategories) {
              // Fallback to old display if no categories found
              return (
                <div className="technical-assessment-content">
                  <div className="assessment-categories">
                    {Object.entries(filteredData).map(([key, value], index) => (
                      <div key={index} className="assessment-item">
                        <div className="assessment-key">
                          {formatFieldName(key)}
                        </div>
                        <div className="assessment-value">{value}</div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            }

            return (
              <div className="technical-assessment-content">
                {/* Render categorized data */}
                {Object.entries(filteredData).map(
                  ([categoryKey, categoryData]) => (
                    <div key={categoryKey} className="assessment-category">
                      <h4 className="category-title">
                        {formatCategoryName(categoryKey)}
                      </h4>
                      <div className="category-items">
                        {Object.entries(categoryData).map(
                          ([fieldKey, fieldValue], index) => (
                            <div key={index} className="assessment-item">
                              <div className="assessment-key">
                                {formatFieldName(fieldKey)}
                              </div>
                              <div className="assessment-value">
                                {fieldValue}
                              </div>
                            </div>
                          ),
                        )}
                      </div>
                    </div>
                  ),
                )}
              </div>
            );
          })()}
        </div>

        {/* Page 4: Valuation & Signatures */}
        <div>
          <div className="page-header">
            <h3>
              <FaFileInvoiceDollar /> Valuation Summary
            </h3>
          </div>

          {/* Valuation Summary */}
          <div className="valuation-summary-section">
            <div className="valuation-cards">
              {Object.entries(getValuationSummary()).map(([key, value]) => {
                const displayKey = key.replace(/([A-Z])/g, " $1").toUpperCase();
                const isCurrency = [
                  "marketValue",
                  "purchasePrice",
                  "afterRepairValue",
                ].includes(key);
                const displayValue =
                  isCurrency && typeof value === "number"
                    ? formatCurrency(value)
                    : value;

                return (
                  <div
                    key={key}
                    className={`valuation-card ${key === "marketValue" ? "highlight-card" : ""}`}
                  >
                    <div className="valuation-card-header">
                      <h4>{displayKey}</h4>
                    </div>
                    <div className="valuation-card-value">{displayValue}</div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Recommendations */}
          <div className="recommendations-section">
            <h3>
              <FaExclamationTriangle /> Recommendations & Notes
            </h3>
            <div className="recommendations-content">
              <p>
                {data.assignedAgent?.observation ||
                  data.inspections?.[0]?.inspectionObservation ||
                  "Vehicle is in good condition. All components functioning properly. Recommended for valuation."}
              </p>
            </div>
          </div>

          {/* Signatures */}
          <div className="signatures-section">
            <div className="signature-grid">
              <div className="signature-item">
                <div className="signature-box">
                  {/* <img
                      src={data?.signNdoc?.agentSign}
                      alt="Agent Signature"
                      className="signature-image"
                    /> */}
                  {data?.signNdoc?.agentSign ? (
                    <img
                      src={data?.signNdoc?.agentSign}
                      alt="Agent Signature"
                      className="signature-image"
                    />
                  ) : (
                    <div className="signature-placeholder">
                      <FaSignature />
                    </div>
                  )}
                  <div className="signature-line"></div>
                </div>
                <div className="signature-details">
                  <h4>
                    <FaSignature /> Inspector's Signature
                  </h4>
                  <p>
                    <strong>Name:</strong>{" "}
                    {data.assignedAgent?.id?.name ||
                      data.assignedAgent?.name ||
                      "Vijay"}
                  </p>
                  <p>
                    <strong>Date:</strong> {formatDate(new Date())}
                  </p>
                  <p>
                    <strong>ID:</strong>{" "}
                    {data.assignedAgent?.id?._id ||
                      data.assignedAgent?.id ||
                      "INS-001"}
                  </p>
                </div>
              </div>

              <div className="signature-item">
                <div className="signature-box">
                  <div className="company-stamp">
                    <FaStamp />
                    <span>COMPANY STAMP</span>
                  </div>
                  <div className="signature-line"></div>
                </div>
                <div className="signature-details">
                  <h4>
                    <FaBuilding /> Company Authorization
                  </h4>
                  <p>
                    <strong>
                      {data?.caseByAgency ? data?.organisation?.name : "mCollect"}
                    </strong>
                  </p>
                  <p>Authorized Signatory</p>
                  <p>
                    <strong>Date:</strong> {formatDate(new Date())}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="disclaimer-section">
            <div className="disclaimer-content">
              <FaExclamationTriangle className="disclaimer-icon" />
              <p>
                <strong>Disclaimer:</strong> This valuation report is based on
                the information provided and physical inspection at the time of
                assessment. Values may vary based on market conditions, vehicle
                modifications, and additional factors not considered during this
                assessment.
              </p>
            </div>
            <div className="report-footer">
              <div className="footer-info">
                <span>Report Generated: {new Date().toLocaleString()}</span>
                <span>Report ID: {data.caseID || "VR-20240107-001"}</span>
                <span>Page 4 of 4</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CSS Styles */}
      <style jsx>{`
        .valuation-report-container {
          font-family: "Segoe UI", "Arial", sans-serif;
          background: #fff;
          min-height: 100vh;
        }

        .action-buttons {
          display: flex;
          gap: 15px;
          margin-bottom: 30px;
          justify-content: center;
          position: sticky;
          top: 20px;
          z-index: 100;
        }

        .print-btn,
        .download-btn {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 12px 24px;
          border: none;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .print-btn {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
        }

        .download-btn {
          background: linear-gradient(135deg, #2ec4b6 0%, #00a8e8 100%);
          color: white;
        }

        .print-btn:hover,
        .download-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
        }

        .valuation-report {
          // max-width: 210mm;
          min-height: 297mm;
          margin: 0;
          position: relative;
        }

        .page {
          padding: 2mm;
          page-break-inside: avoid;
        }

        .page-break {
          page-break-before: always;
        }

        /* Page 1 Styles */
        .report-header {
          border-bottom: 2px solid ${getVehicleColor()};
          padding: 20px;
          background-color: #3d488f;
          margin-bottom: 20px;
          border-radius: 10px;
        }

        .company-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
        }

        .company-logo-section {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 15px;
        }

        .company-logo {
          width: 120px !important;
          height: 80px;
          object-fit: center;
          border-radius: 8px;
          margin-bottom: 5px;
        }
        .company-name h1 {
          margin: 0;
          color: #fff;
          font-size: 24px;
        }

        .company-tagline {
          color: #fff;
          font-size: 14px;
          // margin-top: 5px;
        }

        .company-contact {
          text-align: right;
          font-size: 12px;
          color: #fff;
        }

        .company-contact p {
          margin: 3px 0;
          display: flex;
          align-items: center;
          gap: 8px;
          justify-content: flex-end;
          color: #ffffff;
        }

        .report-title-section {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 15px 25px;
          border-radius: 10px;
          margin-top: 15px;
          background-color: #f2f2f2;
        }

        .report-title-section h2 {
          margin: 0;
          color: #1a1f3d;
          font-size: 22px;
        }

        .report-subtitle {
          color: #1a1f3d;
          font-size: 14px;
          margin-top: 5px;
        }

        .title-icon {
          font-size: 32px;
          color: #1a1f3d;
        }

        .report-badge {
          color: #fff;
          padding: 5px 15px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 600;
          letter-spacing: 1px;
          background-color: #1a1f3d;
        }

        .report-summary-section {
          display: grid;
          grid-template-columns: 2fr 1fr;
          gap: 20px;
          margin: 25px 0;
        }

        .summary-card-main {
          background: #eee;
          border-radius: 10px;
          padding: 20px;
          border-left: 4px solid ${getVehicleColor()};
        }

        .summary-card-main h3 {
          margin: 0 0 15px 0;
          color: #2c3e50;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .summary-details {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 15px;
        }

        .summary-item {
          display: flex;
          flex-direction: column;
        }

        .summary-label {
          font-size: 15px;
          color: #000;
          font-weight: 600;
          margin-bottom: 5px;
        }

        .summary-value {
          font-size: 16px;
          font-weight: 600;
          color: #000;
        }

        .status-section {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        .status-badge-main {
          background: #eee;
          border-radius: 10px;
          padding: 15px;
          text-align: center;
        }

        .status-indicator {
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          margin-right: 8px;
        }

        .status-indicator.completed {
          background: #4caf50;
        }

        .status-indicator.inprogress {
          background: #ff9800;
        }

        .status-text {
          font-weight: 600;
          color: #2c3e50;
        }

        .vehicle-type-display {
          background: ${getVehicleColor()};
          color: white;
          padding: 15px;
          border-radius: 10px;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          font-weight: 600;
        }

        .vehicle-type-display .icon {
          font-size: 32px;
        }

        .client-vehicle-info {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 30px;
          margin: 25px 0;
        }

        .client-info {
          background: #eee;
          border-radius: 10px;
          padding: 20px;
        }

        .client-info h3 {
          margin: 0 0 15px 0;
          color: #2c3e50;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .client-details-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 12px;
        }

        .client-detail {
          display: flex;
          justify-content: space-between;
          padding-bottom: 8px;
          border-bottom: 1px dashed #e0e0e0;
        }

        .detail-label {
          color: #000;
          font-size: 14px;
          font-weight: 600;
        }

        .detail-value {
          font-weight: 600;
          color: #000;
          text-align: right;
        }

        .vehicle-main-image {
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }

        .image-frame {
          border: 2px solid #e0e0e0;
          border-radius: 10px;
          padding: 10px;
          background: white;
          box-shadow: 0 3px 15px rgba(0, 0, 0, 0.1);
        }
        .vehicle-main-img {
          width: 555px;
          max-height: 333px;
          border-radius: 8px;
        }

        .image-caption {
          text-align: center;
          margin-top: 10px;
          font-size: 12px;
          color: #666;
          font-style: italic;
        }

        .vehicle-image-placeholder {
          width: 300px;
          height: 200px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          border-radius: 8px;
          gap: 15px;
          color: ${getVehicleColor()};
          font-weight: 600;
        }

        .vehicle-specifications {
          margin-top: 25px;
        }

        .vehicle-specifications h3 {
          margin: 0 0 15px 0;
          color: #2c3e50;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .specs-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 15px;
        }

        .spec-item {
          background: #eee;
          border-radius: 8px;
          padding: 15px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .spec-label {
          color: #000;
          font-size: 15px;
          display: flex;
          align-items: center;
          gap: 8px;
          font-weight: 600;
        }
        .spec-value {
          font-weight: 600;
          color: #000;
          text-align: right;
        }

        /* Page Header for subsequent pages */
        .page-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 2px solid #e0e0e0;
          padding-bottom: 10px;
          margin-bottom: 20px;
        }

        .page-header h3 {
          margin: 0;
          color: #2c3e50;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .page-number {
          color: #666;
          font-size: 14px;
          font-weight: 600;
          background: #f5f5f5;
          padding: 5px 15px;
          border-radius: 15px;
        }

        /* Media Gallery Styles */
        .media-section {
          margin-bottom: 40px;
        }

        .media-section-title {
          color: #2c3e50;
          margin: 0 0 25px 0;
          display: flex;
          align-items: center;
          gap: 15px;
          font-size: 22px;
          padding-left: 15px;
          position: relative;
        }

        .media-section-title::before {
          content: "";
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 6px;
          height: 24px;
          background: ${getVehicleColor()};
          border-radius: 3px;
        }

        .images-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 25px;
        }

        .media-item {
          background: white;
          border-radius: 20px;
          overflow: hidden;
          transition: all 0.4s ease;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
          border: 2px solid transparent;
        }

        .media-item:hover {
          transform: translateY(-10px) scale(1.02);
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
          border-color: ${getVehicleColor()}40;
        }

        .media-thumbnail-container {
          position: relative;
          height: 200px;
          overflow: hidden;
          background: #f5f5f5;
          text-decoration: none;
          display: block;
        }

        .media-thumbnail-wrapper {
          width: 100%;
          height: 100%;
          position: relative;
          border-radius: 18px 18px 0 0;
          overflow: hidden;
        }

        .media-thumbnail {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .media-item:hover .media-thumbnail {
          transform: scale(1.1);
        }

        .media-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(
            to bottom,
            transparent 50%,
            rgba(0, 0, 0, 0.7) 100%
          );
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-end;
          color: white;
          opacity: 0;
          transition: opacity 0.3s ease;
          padding: 20px;
          text-align: center;
        }

        .media-item:hover .media-overlay {
          opacity: 1;
        }

        .media-overlay svg {
          font-size: 32px;
          margin-bottom: 10px;
        }

        .media-overlay span {
          font-size: 12px;
          font-weight: 500;
          letter-spacing: 0.5px;
        }

        .media-info {
          padding: 20px;
          background: white;
        }

        .media-index {
          margin-bottom: 10px;
        }

        .index-badge {
          display: inline-block;
          background: linear-gradient(
            135deg,
            ${getVehicleColor()} 0%,
            ${getVehicleColor()}b0 100%
          );
          color: white;
          padding: 6px 14px;
          border-radius: 20px;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 1px;
        }

        .media-title {
          font-size: 14px;
          color: #2c3e50;
          font-weight: 600;
          line-height: 1.4;
          height: 40px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .media-placeholder {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #999;
          gap: 15px;
          background: linear-gradient(135deg, #f5f5f5 0%, #e0e0e0 100%);
        }

        .video-section {
          margin-top: 40px;
        }

        .video-container {
          text-align: center;
          background: linear-gradient(
            135deg,
            ${getVehicleColor()}10,
            ${getVehicleColor()}30
          );
          border-radius: 20px;
          padding: 60px 40px;
          cursor: pointer;
          transition: all 0.4s ease;
          position: relative;
          overflow: hidden;
        }

        .video-container:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
        }

        .video-container::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: radial-gradient(
            circle at 30% 30%,
            ${getVehicleColor()}20 0%,
            transparent 50%
          );
        }

        .video-icon {
          font-size: 64px;
          color: ${getVehicleColor()};
          margin-bottom: 25px;
          position: relative;
          z-index: 1;
          filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.2));
          transition: transform 0.3s ease;
        }

        .video-container:hover .video-icon {
          transform: scale(1.1);
        }

        .video-label {
          color: #2c3e50;
          font-weight: 700;
          font-size: 18px;
          position: relative;
          z-index: 1;
        }

        /* Technical Assessment Styles */
        .technical-assessment-content {
          background: #f8f9fa;
          border-radius: 10px;
          padding: 20px;
        }

        .assessment-categories {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 15px;
        }

        .assessment-item {
          background: white;
          border-radius: 8px;
          padding: 15px;
          border-left: 4px solid #1a1f3d;
        }

        .assessment-key {
          font-size: 13px;
          color: #666;
          margin-bottom: 8px;
          text-transform: capitalize;
        }

        .assessment-value {
          font-weight: 600;
          color: #2c3e50;
        }

        .no-assessment-data {
          text-align: center;
          padding: 40px;
          color: #666;
          background: #f8f9fa;
          border-radius: 10px;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 15px;
        }

        .no-assessment-data svg {
          font-size: 48px;
          color: #999;
        }

        /* Valuation Summary Styles */
        .valuation-summary-section {
          margin: 20px 0 30px 0;
        }

        .valuation-cards {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 20px;
        }

        .valuation-card {
          background: #f8f9fa;
          // border-radius: 10px;
          padding: 20px;
          text-align: center;
          // border: 2px solid #e0e0e0;
        }

        .highlight-card {
          background: linear-gradient(
            135deg,
            ${getVehicleColor()}10,
            ${getVehicleColor()}20
          );
          border-color: ${getVehicleColor()};
        }

        .valuation-card-header h4 {
          margin: 0 0 15px 0;
          color: #000;
          font-size: 14px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          font-weight: 700;
        }

        .valuation-card-value {
          font-size: 24px;
          font-weight: 700;
          color: #000;
        }

        .highlight-card .valuation-card-value {
          color: ${getVehicleColor()};
        }

        /* Recommendations Styles */
        .recommendations-section {
          background: #fff8e1;
          border-left: 6px solid #ffc107;
          border-radius: 10px;
          padding: 20px;
          margin: 30px 0;
        }

        .recommendations-section h3 {
          margin: 0 0 15px 0;
          color: #ff8f00;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .recommendations-content p {
          margin: 0;
          color: #5d4037;
          line-height: 1.6;
        }

        /* Signatures Styles */
        .signatures-section {
          margin: 30px 0;
        }

        .signature-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 30px;
        }

        .signature-item {
          text-align: center;
        }

        .signature-box {
          margin-bottom: 15px;
        }

        .signature-image {
          width: 150px;
          height: 80px;
          object-fit: contain;
          border: 1px solid #e0e0e0;
          border-radius: 4px;
          background: white;
        }

        .signature-placeholder {
          width: 150px;
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px dashed #e0e0e0;
          border-radius: 4px;
          color: #999;
          font-size: 32px;
          margin: 0 auto;
        }

        .company-stamp {
          width: 150px;
          height: 80px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          border: 2px solid #e0e0e0;
          border-radius: 4px;
          color: ${getVehicleColor()};
          font-size: 12px;
          font-weight: 600;
          margin: 0 auto;
          gap: 5px;
        }

        .signature-line {
          height: 2px;
          background: #333;
          width: 150px;
          margin: 10px auto;
        }

        .signature-details {
          margin-top: 10px;
        }

        .signature-details h4 {
          margin: 0 0 10px 0;
          color: #2c3e50;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .signature-details p {
          margin: 5px 0;
          color: #666;
          font-size: 13px;
        }

        /* Disclaimer Styles */
        .disclaimer-section {
          border-top: 2px solid #e0e0e0;
          padding-top: 20px;
          margin-top: 30px;
        }

        .disclaimer-content {
          display: flex;
          gap: 15px;
          background: #f8f9fa;
          padding: 15px;
          border-radius: 8px;
          margin-bottom: 15px;
        }

        .disclaimer-icon {
          color: #ff9800;
          font-size: 24px;
          flex-shrink: 0;
        }

        .disclaimer-content p {
          margin: 0;
          color: #666;
          font-size: 12px;
          line-height: 1.5;
        }

        .report-footer {
          text-align: center;
          padding-top: 15px;
          border-top: 1px solid #e0e0e0;
        }

        .footer-info {
          display: flex;
          justify-content: space-between;
          font-size: 11px;
          color: #999;
        }

        /* Loading States */
        .loading-container,
        .error-container,
        .no-data {
          text-align: center;
          padding: 50px;
          background: white;
          border-radius: 12px;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
        }

        .spinner {
          width: 50px;
          height: 50px;
          border: 5px solid #f3f3f3;
          border-top: 5px solid ${getVehicleColor()};
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin: 0 auto 20px;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        .error-icon {
          font-size: 48px;
          color: #f44336;
          margin-bottom: 20px;
        }

        .retry-btn {
          margin-top: 20px;
          padding: 10px 30px;
          background: ${getVehicleColor()};
          color: white;
          border: none;
          border-radius: 25px;
          cursor: pointer;
          font-weight: 600;
        }
        .assessment-category {
          margin-bottom: 25px;
          page-break-inside: avoid;
          break-inside: avoid;
        }

        .category-title {
          color: ${getVehicleColor()};
          font-size: 16px;
          font-weight: 600;
          margin: 0 0 15px 0;
          padding-bottom: 8px;
          border-bottom: 2px solid ${getVehicleColor()}40;
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .category-title::before {
          content: "";
          display: block;
          width: 8px;
          height: 8px;
          background: ${getVehicleColor()};
          border-radius: 50%;
        }

        .category-items {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
          margin-left: 15px;
        }

        .category-items .assessment-item {
          background: #eee;
          border-radius: 6px;
          padding: 12px;
          border-left: 3px solid #1a1f3d;
        }

        .category-items .assessment-key {
          font-size: 15px;
          color: #000;
          margin-bottom: 5px;
          text-transform: capitalize;
          font-weight: 500;
        }
        .category-items .assessment-value {
          color: #000;
          font-size: 14px;
          font-weight: 500;
        }

        /* Single items without category (fallback) */
        .technical-assessment-content > .assessment-categories {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 15px;
        }

        .technical-assessment-content
          > .assessment-categories
          .assessment-item {
          background: #f8f9fa;
          border-radius: 8px;
          padding: 15px;
          border-left: 4px solid #1a1f3d;
        }

        .technical-assessment-content
          > .assessment-categories
          .assessment-item
          .assessment-key {
          font-size: 13px;
          color: #666;
          margin-bottom: 8px;
          text-transform: capitalize;
        }

        .technical-assessment-content
          > .assessment-categories
          .assessment-item
          .assessment-value {
          font-weight: 600;
          color: #2c3e50;
        }

        /* Remove background from main container */
        .valuation-report {
          background: transparent; /* Remove white background */
          border-radius: 20px;
        }
        .valuation-report {
          background: transparent;
          border-radius: 20px;
          margin: 1mm;
        }

        .page {
          padding: 1mm;
          margin-bottom: 20px;
          border-bottom: 1px dashed #000;
        }

        .page:last-child {
          border-bottom: none;
        }
        /* Screen-only styles */
        @media screen {
          .valuation-report {
            background: transparent;
            border-radius: 20px;
            // margin: 11mm;
          }

          .page {
            padding: 1mm;
            margin-bottom: 20px;
            border-bottom: 1px dashed #000;
          }

          .page:last-child {
            border-bottom: none;
          }
        }
      `}</style>
    </div>
  );
};

export default ValuationReport;
